import React from 'react'
/* import { Link } from 'gatsby' */
import classnames from 'classnames'
import PropTypes from 'prop-types'

import style from './Nav.module.scss'
import I18nLink from '../../i18n/Link'

class Nav extends React.Component {
  static propTypes = {
    classNames: PropTypes.string,
    showMobile: PropTypes.bool,
    menuNav: PropTypes.array,
  }

  render() {
    const { menuNav, showMobile } = this.props

    return (
      <React.Fragment>
        <ul
          className={classnames(style.nav, showMobile ? style.mobileNav : '')}
        >
          {menuNav.map(x => (
            <li className={classnames(style.item)} key={`nav-${x.title}`}>
              <I18nLink to={x.href}>{x.title}</I18nLink>
            </li>
          ))}
        </ul>
      </React.Fragment>
    )
  }
}

export default Nav
